import { useEffect, useRef, useState } from "react";
import { apiUrl } from "../../base/utils";
import { invokeGetService } from "../../service";
import { Button, Dropdown } from "react-bootstrap";
import { WMSSelect } from '../../widgets/selectbox';
import HOCAutoLogout from "../autologout";

function Journal(props: any) {
    const [journals, setJournal] = useState([]);
    const [journalsvalue, setJournalsvalue] = useState('');

    const handleFormSelection=(e: any, item: any, i: any, field: string)=>{
        console.log(e,"ewrui")
    }

    return (
        <div>
            <div className="page-title">
            <h3>Journal & Issue Config</h3>
          </div>

          <div className='row'>
                    <div className='col-lg-3 col-md-12 col-sm-12 form-group'>
                        <label>Journal</label>
                        <WMSSelect
                            className="form-control"
                            placeHolder={'Select Journal'}
                            options={journals}
                            name="fileTypes"
                            value={journalsvalue}
                            isMulti={false}
                            onChange={(e: any) => handleFormSelection(e, 'role', 'role', "roles")}
                            id="fileTypes"
                        />
                    </div>

                </div>
                <div className='row'>
                    <div className='col-lg-3 col-md-12 col-sm-12 form-group'>
                        <label>Volume(Issue)</label>
                        <WMSSelect
                            className="form-control"
                            placeHolder={'Select vol/issue'}
                            options={journals}
                            name="fileTypes"
                            value={journalsvalue}
                            isMulti={false}
                            onChange={(e: any) => handleFormSelection(e, 'role', 'role', "roles")}
                            id="fileTypes"
                        />
                    </div>

                </div>
        </div>
            )
}


export default HOCAutoLogout(Journal);